<template>
  <div>
    <h1 class="page-title">修改密码</h1>
    <div class="soft-card password-card">
      <el-form
        ref="passwordForm"
        label-width="100px"
        :model="form"
        :rules="rules"
      >
        <el-form-item label="原密码" prop="oldPassword">
          <el-input v-model="form.oldPassword" show-password clearable />
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="form.newPassword" show-password clearable />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="loading" @click="submit">
            保存新密码
          </el-button>
        </el-form-item>
      </el-form>
      <div class="form-tip">如果忘记管理员密码，可联系运维人员通过数据库重置。</div>
    </div>
  </div>
</template>

<script>
import { updatePassword } from '../api'

export default {
  data() {
    return {
      loading: false,
      form: {
        oldPassword: '',
        newPassword: ''
      },
      rules: {
        oldPassword: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, message: '新密码至少6位', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    submit() {
      this.$refs.passwordForm.validate(valid => {
        if (!valid) {
          return
        }
        this.loading = true
        updatePassword(this.form)
          .then(() => {
            this.$message.success('密码已修改，请重新登录')
            localStorage.removeItem('adminToken')
            localStorage.removeItem('adminUser')
            this.$router.replace('/login')
          })
          .finally(() => {
            this.loading = false
          })
      })
    }
  }
}
</script>

<style scoped>
.password-card {
  max-width: 560px;
  padding: 28px;
}

.form-tip {
  margin-top: 18px;
  padding: 10px 14px;
  border-radius: 12px;
  background: #f5f8fb;
  color: #8a98aa;
  font-size: 12px;
  line-height: 1.6;
}
</style>
